import React from 'react';

import { ListItemButton, ListItemIcon } from '@mui/material';
import { Link } from 'react-router-dom';

import SectionTitle from './SectionTitle';
import { tokens } from '../theme';

interface SelectedListButtonProps {
  label1: string;
  label2: string;
  path: string; // assuming the To type you mentioned is string. Replace with appropriate type if not.
  icon: React.ElementType; // assuming it's a React component. Adjust as needed.
  isSelected: boolean;
  onClick: (path: string) => void;
  onPress: (path: string) => (event: React.KeyboardEvent) => void;
}

export default function SelectedListButton({
  label1,
  label2,
  path,
  icon: IconComponent,
  isSelected,
  onClick,
  onPress,
}: SelectedListButtonProps) {
  return (
    <ListItemButton
      component={Link}
      to={path}
      selected={isSelected}
      aria-current={isSelected ? 'page' : undefined}
      onClick={(event) => {
        if (
          event.button === 0 &&
          !event.metaKey &&
          !event.ctrlKey &&
          !event.shiftKey &&
          !event.altKey
        ) {
          // onClick navigates; stop the link from navigating again (two history entries).
          event.preventDefault();
          onClick(path);
        }
      }}
      onKeyDown={(event) => onPress?.(path)?.(event)}
      // Theme colours, so the menu reads correctly in light, high-contrast and dark modes.
      sx={{
        padding: '20px',
        '&:hover, &.Mui-selected:hover': {
          backgroundColor: tokens.surfaceContainer,
          color: tokens.onSurface,
          cursor: 'pointer',
          '& .blue, & .grey': { color: tokens.onSurface },
        },
        '&.Mui-selected, &.Mui-selected:hover': {
          backgroundColor: tokens.primaryFixed,
          color: tokens.primary,
          '& .blue, & .grey': { color: tokens.primary, fontWeight: '700' },
        },
        '&.Mui-focusVisible, &.Mui-selected.Mui-focusVisible': {
          backgroundColor: tokens.primaryFixed,
          color: tokens.primary,
          outline: `3px solid ${tokens.focus}`,
          outlineOffset: '-3px',
          '& .blue, & .grey': { color: tokens.primary },
        },
      }}
    >
      <ListItemIcon>
        <IconComponent sx={{ color: 'inherit' }} />
      </ListItemIcon>
      <SectionTitle
        first={label1}
        second={label2}
        type='menu'
        variant='subtitle1'
        padding='0'
      />
    </ListItemButton>
  );
}
